document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.signature-looks').forEach(function (section) {
    var autoplay = section.dataset.autoplay === 'true';
    var track = section.querySelector('.signature-looks__track');
    var prevBtn = section.querySelector('.signature-looks__nav--prev');
    var nextBtn = section.querySelector('.signature-looks__nav--next');

    function scrollByOneItem(direction) {
      var item = track.querySelector('.signature-looks__item');
      if (!item) return;
      var gap = parseInt(getComputedStyle(track).gap || '16', 10);
      var amount = item.getBoundingClientRect().width + gap;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByOneItem(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByOneItem(1); });

    // Mute button sits above the clickable product overlay via z-index,
    // so it intercepts the tap without needing stopPropagation.
    section.querySelectorAll('.signature-looks__mute').forEach(function (btn) {
      var video = btn.closest('.signature-looks__item').querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.dataset.muted = video.muted ? 'true' : 'false';
        btn.querySelector('.signature-looks__mute-icon').textContent = video.muted ? '🔇' : '🔊';
      });
    });

    if (!autoplay) return;

    var videos = section.querySelectorAll('.signature-looks__video');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {
              // Autoplay can be blocked by the browser; fail silently
            });
          } else {
            video.pause();
          }
        });
      },
      { root: track, threshold: 0.6 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  });
});
